var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_7027)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8506 1.37493C18.8506 1.05288 18.7226 0.744024 18.4949 0.516301C18.2672 0.288579 17.9583 0.160645 17.6363 0.160645H3.06487C2.74282 0.160645 2.43396 0.288579 2.20624 0.516301C1.97852 0.744024 1.85059 1.05288 1.85059 1.37493C1.85059 1.69698 1.97852 2.00584 2.20624 2.23356C2.43396 2.46128 2.74282 2.58922 3.06487 2.58922H17.6363C17.9583 2.58922 18.2672 2.46128 18.4949 2.23356C18.7226 2.00584 18.8506 1.69698 18.8506 1.37493Z",
    fill: "#347D73"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8506 7.44524C18.8506 7.12319 18.7226 6.81434 18.4949 6.58661C18.2672 6.35889 17.9583 6.23096 17.6363 6.23096H3.06487C2.74282 6.23096 2.43396 6.35889 2.20624 6.58661C1.97852 6.81434 1.85059 7.12319 1.85059 7.44524C1.85059 7.76729 1.97852 8.07615 2.20624 8.30387C2.43396 8.5316 2.74282 8.65953 3.06487 8.65953H17.6363C17.9583 8.65953 18.2672 8.5316 18.4949 8.30387C18.7226 8.07615 18.8506 7.76729 18.8506 7.44524Z",
    fill: "#347D73"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8506 13.5155C18.8506 13.1935 18.7226 12.8846 18.4949 12.6569C18.2672 12.4292 17.9583 12.3012 17.6363 12.3012H10.3506C10.0285 12.3012 9.71967 12.4292 9.49194 12.6569C9.26422 12.8846 9.13629 13.1935 9.13629 13.5155C9.13629 13.8376 9.26422 14.1464 9.49194 14.3742C9.71967 14.6019 10.0285 14.7298 10.3506 14.7298H17.6363C17.9583 14.7298 18.2672 14.6019 18.4949 14.3742C18.7226 14.1464 18.8506 13.8376 18.8506 13.5155Z",
    fill: "#347D73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_7027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    fill: "white",
    transform: "translate(0.989014 0.0200195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarIcon);
export default __webpack_public_path__ + "static/media/bar-icon.2867ad5e6af2283f9c36a0ff3b785b17.svg";
export { ForwardRef as ReactComponent };